import { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';

const faqKeys = [1, 2, 3, 4, 5, 6];

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" data-testid="faq-section" className="py-14 lg:py-20 bg-[#FAF8F5] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ top: '15%' }}
          animate={{ x: ['10%', '-20%'] }} transition={{ duration: 18, repeat: Infinity, ease: 'linear', repeatType: 'reverse' }}>
          <span className="text-[20vw] font-bold text-[#1A1816]/[0.025] tracking-[-0.05em] font-sans leading-none">
            FAQ&nbsp;&nbsp;&nbsp;QUESTIONS&nbsp;&nbsp;&nbsp;FAQ
          </span>
        </motion.div>
      </div>
      <div className="max-w-[800px] mx-auto px-6 lg:px-12">
        <motion.div className="mb-12" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[1px] bg-[#C9A96E]" />
            <span className="text-[9px] font-semibold tracking-[0.3em] uppercase text-[#8A857D]">{t('faq.label')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-bold text-[#1A1816] leading-tight">
            {t('faq.title1')} <span className="font-serif italic text-[#C9A96E]">{t('faq.title2')}</span>
          </h2>
        </motion.div>

        <div className="space-y-0">
          {faqKeys.map((num, i) => (
            <motion.div
              key={num}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#1A1816]/10"
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between py-5 text-left group"
              >
                <span className="text-sm sm:text-base font-medium text-[#1A1816] pr-4">{t(`faq.q${num}`)}</span>
                <ChevronDown className={`w-4 h-4 text-[#8A857D] flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} />
              </button>
              <motion.div
                initial={false}
                animate={{ height: openIndex === i ? 'auto' : 0, opacity: openIndex === i ? 1 : 0 }}
                transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                className="overflow-hidden"
              >
                <p className="pb-5 text-sm text-[#8A857D] leading-relaxed">{t(`faq.a${num}`)}</p>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
